import { TIncident, TAlert } from '@core/modules/mdr/cases'
import { TabContent } from './caseTabCommunication.styles'

interface Props {
    data: TIncident | TAlert
}

const CaseTabCommunication = ({ data }: Props) => {
    return <TabContent data-testid="communication-content">TBD</TabContent>
}

export default CaseTabCommunication
